/* Formelle theme – product.js: gallery + bundle selector */
(function () {
  'use strict';
  var F = window.Formelle || {};

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!track) return;

    function setActive(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-thumb'), 10);
        var slide = track.children[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(i);
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setActive(i);
      });
    }, { passive: true });

    root.goToMedia = function (mediaId) {
      if (!mediaId) return;
      var slides = Array.prototype.slice.call(track.children);
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx >= 0) {
        track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActive(idx);
      }
    };
  }

  /* ---------- Bundle ---------- */
  function initBundle(section, form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var tiers = Array.prototype.slice.call(form.querySelectorAll('[data-tier]'));
    var atc = form.querySelector('[data-atc]');
    var atcLabel = form.querySelector('[data-atc-label]');
    var atcPrice = form.querySelector('[data-atc-price]');
    var errorEl = form.querySelector('[data-bundle-error]');
    var defaultLabel = atcLabel ? atcLabel.textContent.trim() : F.strings.addToCart;
    var singleVariant = variants.length === 1;
    var useCompareAt = form.getAttribute('data-compare-mode') === 'compare_at';

    function selectedTier() {
      return tiers.find(function (t) { return t.classList.contains('is-selected'); }) || tiers[0];
    }

    function optionEls(slot) {
      return Array.prototype.slice.call(slot.querySelectorAll('[data-option-index]'))
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); });
    }

    function slotOptions(slot) {
      return optionEls(slot).map(function (el) {
        if (el.tagName === 'SELECT') return el.value;
        var checked = el.querySelector('input:checked');
        return checked ? checked.value : undefined;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === '' || o === opts[i]; });
      });
    }

    function slotMissing(tier) {
      if (singleVariant) return false;
      return Array.prototype.slice.call(tier.querySelectorAll('[data-slot]')).some(function (slot) {
        return slotOptions(slot).some(function (o) { return o === ''; });
      });
    }

    function slotVariants(tier) {
      if (singleVariant) {
        var n = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var arr = [];
        for (var i = 0; i < n; i++) arr.push(variants[0]);
        return arr;
      }
      return Array.prototype.slice.call(tier.querySelectorAll('[data-slot]')).map(function (slot) {
        return findVariant(slotOptions(slot));
      });
    }

    function refreshSoldOutLabels(slot) {
      var current = slotOptions(slot);
      optionEls(slot).forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        var isOk = function (value) {
          var test = current.slice();
          test[idx] = value;
          var v = findVariant(test);
          return v && v.available;
        };
        if (el.tagName === 'SELECT') {
          Array.prototype.forEach.call(el.options, function (opt) {
            if (opt.value === '') return;
            var label = opt.getAttribute('data-label') || opt.value;
            opt.textContent = isOk(opt.value) ? label : label + ' – ' + F.strings.soldOut.toLowerCase();
          });
        } else {
          el.querySelectorAll('input[type="radio"]').forEach(function (r) {
            r.closest('.swatch').classList.toggle('is-soldout', !isOk(r.value));
          });
          var lbl = el.querySelector('[data-swatch-label]');
          if (lbl) lbl.textContent = current[idx] || '';
        }
      });
      var v = findVariant(current);
      slot.classList.toggle('is-unavailable', !v || !v.available);
    }

    /* Buy X get Y: the `free` cheapest items cost nothing (same rule as
       Shopify's automatic "Buy X get Y" discount). */
    function computeTier(tier) {
      var free = parseInt(tier.getAttribute('data-free'), 10) || 0;
      var list = slotVariants(tier);
      var missing = slotMissing(tier);
      var prices = [], compare = 0, ok = true;
      list.forEach(function (v) {
        if (missing) v = v || variants[0];
        if (!v) { ok = false; return; }
        if (!missing && !v.available) { ok = false; return; }
        prices.push(v.price);
        compare += useCompareAt ? Math.max(v.compare_at_price || 0, v.price) : v.price;
      });
      prices.sort(function (a, b) { return a - b; });
      var total = prices.slice(Math.min(free, prices.length)).reduce(function (s, p) { return s + p; }, 0);
      var fixed = parseInt(tier.getAttribute('data-price'), 10) || 0;
      if (fixed > 0 && fixed < total) total = fixed;
      return { total: total, compare: compare, save: compare - total, ok: ok, missing: missing, list: list };
    }

    function render() {
      tiers.forEach(function (tier) {
        var r = computeTier(tier);
        var priceEl = tier.querySelector('[data-tier-price]');
        var compareEl = tier.querySelector('[data-tier-compare]');
        var saveEl = tier.querySelector('[data-tier-save]');
        if (r.ok) {
          if (priceEl) priceEl.textContent = F.formatMoney(r.total);
          if (compareEl) { compareEl.textContent = F.formatMoney(r.compare); compareEl.hidden = r.save <= 0; }
          if (saveEl) {
            saveEl.hidden = r.save <= 0;
            var b = saveEl.querySelector('[data-amount]');
            if (b) b.textContent = F.formatMoney(r.save);
          }
        }
      });

      var sel = selectedTier();
      if (!sel || !atc) return;
      var res = computeTier(sel);
      atc.disabled = !res.ok && !res.missing;
      if (res.missing) res.ok = true;
      if (errorEl && !(errorEl.textContent === F.strings.chooseSize && computeTier(sel).missing)) {
        errorEl.hidden = res.ok;
        errorEl.textContent = res.ok ? '' : F.strings.unavailable;
      }
      if (atcLabel) atcLabel.textContent = res.ok ? defaultLabel : F.strings.soldOut;
      if (atcPrice) atcPrice.textContent = res.ok ? '· ' + F.formatMoney(res.total) : '';

      var sticky = section.querySelector('[data-sticky-dynamic]');
      if (sticky && res.ok) {
        var st = sticky.querySelector('[data-sticky-title]');
        var sp = sticky.querySelector('[data-sticky-price]');
        if (st) st.textContent = sel.getAttribute('data-title') || st.textContent;
        if (sp) sp.textContent = F.formatMoney(res.total) + (res.save > 0 ? ' · ' + F.strings.save + ' ' + F.formatMoney(res.save) : '');
      }
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.tier__radio');
      if (radio) {
        radio.addEventListener('change', function () {
          tiers.forEach(function (t) { t.classList.toggle('is-selected', t === tier); });
          render();
        });
      }
      tier.querySelectorAll('[data-slot]').forEach(function (slot) {
        refreshSoldOutLabels(slot);
        slot.addEventListener('change', function () {
          refreshSoldOutLabels(slot);
          slot.querySelectorAll('select.is-missing').forEach(function (sel) { if (sel.value !== '') sel.classList.remove('is-missing'); });
          var v = findVariant(slotOptions(slot));
          if (v && v.media_id && section.goToMedia) section.goToMedia(v.media_id);
          var th = slot.querySelector('[data-slot-thumb]');
          if (th && v && v.image) th.src = v.image;
          render();
        });
      });
    });

    if (!selectedTier() && tiers[0]) {
      tiers[0].classList.add('is-selected');
      var r0 = tiers[0].querySelector('.tier__radio');
      if (r0) r0.checked = true;
    }

    if (atc) {
      atc.addEventListener('click', function () {
        var tier = selectedTier();
        var res = computeTier(tier);
        if (res.missing) {
          tier.querySelectorAll('select[data-required]').forEach(function (sel) { sel.classList.toggle('is-missing', sel.value === ''); });
          if (errorEl) { errorEl.hidden = false; errorEl.textContent = F.strings.chooseSize; }
          var first = tier.querySelector('select.is-missing');
          if (first) { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); first.focus({ preventScroll: true }); }
          return;
        }
        if (!res.ok) { render(); return; }
        var grouped = {};
        res.list.forEach(function (v) { grouped[v.id] = (grouped[v.id] || 0) + 1; });
        var items = Object.keys(grouped).map(function (id) {
          return { id: parseInt(id, 10), quantity: grouped[id] };
        });
        (tier.getAttribute('data-gifts') || '').split(',').forEach(function (gid) {
          gid = parseInt(gid, 10);
          if (gid) items.push({ id: gid, quantity: 1, properties: { _gift: '1' } });
        });
        atc.disabled = true;
        atc.classList.add('is-loading');
        if (atcLabel) atcLabel.textContent = F.strings.adding;
        F.addItems(items)
          .catch(function (err) {
            if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message || F.strings.error; }
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            render();
          });
      });
    }

    render();
  }

  /* ---------- Size finder (uses the size table: col2 = waist, col3 = weight) ---------- */
  function parseRange(txt) {
    var m = String(txt || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d+)?)\D+(\d+(?:[.,]\d+)?)/);
    if (!m) return null;
    return [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))];
  }
  function initSizeFinder(root) {
    root.querySelectorAll('[data-size-finder]').forEach(function (el) {
      if (el.__init) return; el.__init = true;
      var rows = (el.getAttribute('data-table') || '').split(/\n/).map(function (r) { return r.split('|').map(function (c) { return c.trim(); }); })
        .filter(function (r) { return r.length >= 2 && r[0]; });
      rows = rows.slice(1).map(function (r) { return { size: r[0], waist: parseRange(r[1]), weight: parseRange(r[2]) }; });
      var out = el.querySelector('[data-sf-result]');
      function pick(val, key) {
        if (!val) return null;
        for (var i = 0; i < rows.length; i++) {
          var rg = rows[i][key];
          if (rg && val >= rg[0] && val <= rg[1]) return { size: rows[i].size, between: false };
        }
        for (var j = 0; j < rows.length - 1; j++) {
          var a = rows[j][key], b = rows[j + 1][key];
          if (a && b && val > a[1] && val < b[0]) return { size: rows[j + 1].size, between: true };
        }
        return null;
      }
      el.querySelector('[data-sf-go]').addEventListener('click', function () {
        var w = parseFloat(el.querySelector('[data-sf-waist]').value);
        var kg = parseFloat(el.querySelector('[data-sf-weight]').value);
        var r = pick(w, 'waist') || pick(kg, 'weight');
        out.hidden = false;
        if (!r) { out.textContent = el.getAttribute('data-r-none'); out.classList.remove('is-ok'); return; }
        out.textContent = (r.between ? el.getAttribute('data-r-between') : el.getAttribute('data-r')).replace('[size]', r.size);
        out.classList.add('is-ok');
        // pre-select that size in every empty size dropdown of the selected bundle
        var section = el.closest('[data-product-section]');
        if (section) {
          section.querySelectorAll('.tier select[data-option-index]').forEach(function (sel) {
            var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === r.size; });
            if (opt) { sel.value = r.size; sel.classList.remove('is-missing'); sel.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-section]').forEach(function (section) {
      if (section.__formelleInit) return;
      section.__formelleInit = true;
      initGallery(section);
      initSizeFinder(section);
      section.querySelectorAll('[data-product-form]').forEach(function (form) { initBundle(section, form); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
